// import React from "react";
// import { FaHome, FaShoppingCart, FaUser, FaSearch } from "react-icons/fa";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// const MobileBottomNav = () => {

//   const navigate = useNavigate();
//   const location = useLocation();

//   const cartCount = useSelector((state) => state.cart.cartCount);

//   const navItems = [
//     { name: "Home", icon: <FaHome />, path: "/" },
//     { name: "Search", icon: <FaSearch />, path: "/search" },
//     { name: "Cart", icon: <FaShoppingCart />, path: "/cart" },
//     { name: "Account", icon: <FaUser />, path: "/account" },
//   ];

//   return (
//     <div className="fixed bottom-0 left-0 w-full bg-white border-t shadow-md z-50 md:hidden">

//       <div className="flex justify-around items-center py-2">

//         {navItems.map((item, index) => {

//           const isActive = location.pathname === item.path;

//           return (
//             <div
//               key={index}
//               onClick={() => navigate(item.path)}
//               className={`flex flex-col items-center text-xs cursor-pointer transition 
//               ${isActive ? "text-black font-medium" : "text-gray-500"}`}
//             >

//               <div className="relative text-lg">

//                 {item.icon}

//                 {/* CART BADGE */}
//                 {item.name === "Cart" && cartCount > 0 && (
//                   <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
//                     {cartCount}
//                   </span>
//                 )}

//               </div>

//               <span className="mt-1">{item.name}</span>

//             </div>
//           );
//         })}

//       </div>

//     </div>
//   );
// };

// export default MobileBottomNav;
import React from "react";
import { FaHome, FaShoppingCart, FaUser, FaSearch } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

const MobileBottomNav = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const cartCount = useSelector((state) => state.cart.cartCount);

  const navItems = [
    { name: "Home", icon: <FaHome />, path: "/" },
    { name: "Search", icon: <FaSearch />, path: "/search" },
    { name: "Cart", icon: <FaShoppingCart />, path: "/cart" },
    { name: "Account", icon: <FaUser />, path: "/account" },
  ];

  return (
    <div className="fixed bottom-0 left-0 w-full z-50 md:hidden">

      {/* FULL WIDTH BACKGROUND */}
      <div className="w-full bg-gray-400 border-t shadow-md">

        <div className="flex justify-around items-center py-3">

          {navItems.map((item, index) => {

            const isActive = location.pathname === item.path;

            return (
              <motion.div
                key={index}
                onClick={() => navigate(item.path)}
                whileTap={{ scale: 0.85 }}
                className="flex flex-col items-center justify-center flex-1 cursor-pointer"
              >

                <motion.div
                  animate={{
                    scale: isActive ? 1.2 : 1,
                    color: isActive ? "#1677A8" : "#353939"
                  }}
                  transition={{ type: "spring", stiffness: 300 }}
                  className="relative text-xl"
                >

                  {item.icon}

                  {/* CART BADGE */}
                  {item.name === "Cart" && cartCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                      {cartCount}
                    </span>
                  )}

                </motion.div>

                <span
                  className={`text-[11px] mt-1 ${
                    isActive ? "text-[#1677A8] font-medium" : "text-gray-700"
                  }`}
                >
                  {item.name}
                </span>

              </motion.div>
            );
          })}

        </div>

      </div>

    </div>
  );
};

export default MobileBottomNav;